import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EcCalendar from "@/components/widgets/EcCalendar.vue";
import { CalendarEventModule } from "@/store/modules/calendarEvent.modules";
import { CalendarEventRequestModel } from "@/store/models/calendarEvent/calendarEventRequestDTO";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { DateFormatConstant } from "@/store/DateFormatConstants";
let Calendar = /** @class */ (() => {
    let Calendar = class Calendar extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Calendar";
            this.calendarEventRequest = new CalendarEventRequestModel();
            this.selectedStateId = "";
            this.pageIsLoading = true;
            this.isPageLoading = true;
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Calendar",
                    href: "#",
                },
            ];
            this.count = 0;
        }
        onNavigationClick(startDate, endDate) {
            if (this.pageIsLoading === true) {
                this.isPageLoading = false;
            }
            else if (this.pageIsLoading === false) {
                this.isPageLoading = true;
            }
            const previousStartDate = this.calendarEventRequest.startDate;
            const previousEndDate = this.calendarEventRequest.endDate;
            this.AddEcCalendarData(startDate, endDate);
            if (startDate && previousStartDate) {
                const endDateChanged = endDate.toLocaleDateString() !== previousEndDate.toLocaleDateString();
                const startDateChanged = startDate.toLocaleDateString() !== previousStartDate.toLocaleDateString();
                if (startDateChanged || endDateChanged) {
                    this.GetCalendarEvents();
                }
                else {
                    this.isPageLoading = false;
                }
            }
        }
        AddEcCalendarData(startDate, endDate) {
            this.calendarEventRequest.startDate = startDate;
            this.calendarEventRequest.endDate = endDate;
            const formatDate = (date) => {
                const day = date
                    .getDate()
                    .toString()
                    .padStart(2, "0");
                const month = (date.getMonth() + 1).toString().padStart(2, "0");
                const year = date.getFullYear();
                return this.dateFormat === DateFormatConstant.DateFormat.DateFormatMDY() ? `${month}/${day}/${year}` : `${day}/${month}/${year}`;
            };
            this.calendarEventRequest.startDateAsString = formatDate(startDate);
            this.calendarEventRequest.endDateAsString = formatDate(endDate);
            if (this.selectedStateId != "") {
                this.calendarEventRequest.stateId = this.selectedStateId;
            }
            else {
                this.calendarEventRequest.stateId = this.emptyGuid.toString();
            }
        }
        updateCalendarEvents() {
            this.isPageLoading = true;
            if (this.selectedStateId == "") {
                this.calendarEventRequest.stateId = this.emptyGuid.toString();
            }
            else {
                this.calendarEventRequest.stateId = this.selectedStateId;
            }
            this.GetCalendarEvents();
        }
        GetCalendarEvents() {
            CalendarEventModule.GetEventsForCalendarView(this.calendarEventRequest).then((response) => {
                if (response) {
                    this.pageIsLoading = false;
                    this.isPageLoading = false;
                }
            });
        }
        get states() {
            return CalendarEventModule.states;
        }
        get calendarEvents() {
            return CalendarEventModule.viewCalendarEvent;
        }
        created() {
            this.GetCalendarEvents();
        }
    };
    Calendar = __decorate([
        Component({
            name: "Calendar",
            components: {
                Layout,
                PageHeader,
                Loader,
                EcCalendar,
                SectionLoader,
            },
        })
    ], Calendar);
    return Calendar;
})();
export default Calendar;
